<template>
  <div class="container">
    <b-row>
      <b-container>
        <h2 class="text-center">
          {{labels.title}}
        </h2>
      </b-container>
    </b-row>
    <div class="row col-md-12">
      <div class="col-md-12 d-flex justify-content-end">
        <td>
          <md-button style="background-color: #2e507a; width: 35px; height: 35px;" class="md-fab md-primary" @click="createRol()">
            <md-icon>add</md-icon>
          </md-button>
        </td>
      </div>
    </div>
    <div class="row col-md-12 justify-content-center mt-4">
      <md-table md-card md-header v-model="roles">
        <md-table-row slot="md-table-row" slot-scope="{ item }">
          <md-table-cell :md-label="labels.name" class="border">{{ item.nombre }}</md-table-cell>
          <md-table-cell :md-label="labels.description" class="border">{{ item.descripcion }}</md-table-cell>
          <md-table-cell :md-label="labels.associate" class="border">
            <md-button style="background-color: #2e507a; width: 35px; height: 35px;" class="md-fab md-primary" @click="asociaMenu(item.id)">
              <md-icon>menu</md-icon>
            </md-button>
          </md-table-cell>
          <md-table-cell :md-label="labels.edit" class="border">
            <md-button style="background-color: #e5ac00; width: 35px; height: 35px;" class="md-fab md-primary" @click="editRol(item.id)">
              <md-icon>edit</md-icon>
            </md-button>
          </md-table-cell>
          <md-table-cell :md-label="labels.inactivate" class="border">
            <md-button style="background-color: #cd2838; width: 35px; height: 35px;" class="md-fab md-primary" @click="inactivarRol(item.id)">
              <md-icon>delete</md-icon>
            </md-button>
          </md-table-cell>
        </md-table-row>
      </md-table>
    </div>
    <Create :showDialogCreate="showDialogCreate" @closeModal="cerrarModal" />
    <Edit :showDialogEdit="showDialogEdit" :Item="itemSelected" @closeModal="cerrarModal"/>
    <ModalAsociaMenu :modAsociaMenu="modAsociaMenu" :IdRol="rolId" @closeModal="cerrarModal"></ModalAsociaMenu>
  </div>
</template>

<script>
import Rol from "@/services/Roles";
import Edit from "./Edit.vue"
import Create from './Create.vue';
import ModalAsociaMenu from "./ModalAsociaMenu.vue";

export default {
    name: "Roles",
    components:{
      Edit,
      Create,
      ModalAsociaMenu
    },
    data: () => ({
        isLoading: false,
        error: false,
        isEmpty: false,
        searchRoles: null,
        roles:[],
        elementosPorPagina:10,
        paginaActual: 1,
        datosPaginados: [],
        pages:[],
        showDialogEdit: false,
        itemSelected: {},
        listRol:[],
        showDialogCreate: false,
        modAsociaMenu: false,
        rolId: ""
    }),
    computed:{
        labels(){
            if (this.$store.state._language == "es-ES") {
                return {
                    title: "Roles",
                    instructive: ["Bienvenid@ a la plataforma para la visualización y administración de roles"],
                    create: "Crear",
                    name: "Nombre",
                    description: "Descripción",
                    associate: "Asociar menú",
                    edit: "Editar",
                    inactivate: "Inactivar",
                }
            }else {
                return {
                    title: "Roles",
                    instructive: ["Welcome to the platform for the visualization and manage of roles."],
                    create: "Create",
                    name: "Name",
                    description: "Description",
                    associate: "Associate menu",
                    edit: "Edit",
                    inactivate: "Inactivate",
                }
            }
        }
    },
    methods:{
      cerrarModal(val){
        this.showDialogEdit = val
        this.showDialogCreate = val
        this.modAsociaMenu = val
      },
      asociaMenu(idRol){
        // console.log(idRol)
        this.rolId = idRol
        this.modAsociaMenu = true
      },
        editRol(id){
            // console.log(id)
            // this.itemSelected = id;
            this.showDialogEdit = true;

            Rol.getAllRolesById(id)
            .then((rta) => {
              let datos = rta.data.rolById;
              // console.log(datos[0])
              this.itemSelected = datos[0];
            })
            .catch((error) => {
              console.log(error);
              this.error = true;
            })
            .finally(() => {
                this.isLoading = false;
            });
        },
        createRol(){
          this.showDialogCreate = true

        },
        inactivarRol(id){
            this.isLoading = true;
            Rol.inactivarRol(id)
            .then(() => {
                // console.log(rta)
                this.$toast.success("Rol inactivado correctamente")
                this.isLoading = false;
            })
            .catch(() => {
                this.$toast.error("El rol no se pudo inactivar")
            })
            .finally(() => {
                this.isLoading = false;
            });
        },
    },
    mounted(){
        this.isLoading = true;
        Rol.getAllRoles()
        .then((rta) => {
            // console.log(rta.data.roles)
            this.roles = rta.data.roles;
            this.getDataPagina(1);
        })
        .catch(() => {
        // console.log(error);
        this.error = true;
        })
        .finally(() => {
        this.isLoading = false;
        });
    }
}
</script>
<style src="../main.css">
</style>